module.exports = __webpack_public_path__ + "static/85ba1b86.success.gif";